import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CalendarFieldInput = (props) => {
  const inputWrapperClasses = classNames(
    {
      'ds-text-input calendar-input': props.isMobileOptimization,
    },
  );

  return (
    <div className={inputWrapperClasses}>
      <input
        className={`input-large datepicker-${props.datepickerType}`}
        type="text"
        id={props.id.toLowerCase()}
        name={props.id}
        onFocus={props.onFocus}
        onChange={props.onChange}
        value={props.value}
        placeholder={props.placeholder}
        data-date-date={props.placeholder}
        data-date-format="mm/dd/yyyy"
      />
    </div>
  );
};

CalendarFieldInput.defaultProps = {
  isMobileOptimization: false,
  placeholder: '',
  value: '',
};

CalendarFieldInput.propTypes = {
  datepickerType: PropTypes.oneOf(
    [
      'calendar',
      'month',
    ],
  ).isRequired,
  id: PropTypes.string.isRequired,
  isMobileOptimization: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default CalendarFieldInput;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/CalendarField/CalendarFieldInput.jsx